import { callApi } from './api';

import { ApiResult } from '@/types/api';
import { User } from '@/types/user';

type UserResponse = {
  total: number;
  users: User[];
};

export const getUsers = async (
  limit: string,
  offset: string,
  word?: string,
  officeIDs?: number[]
): Promise<ApiResult<UserResponse>> => {
  const params = new URLSearchParams({
    limit: limit,
    offset: offset,
  });
  if (word) {
    params.append('word', word);
  }
  const searchParams = new URLSearchParams(params);
  const { status, result } = await callApi<UserResponse>(
    `users`,
    'GET',
    searchParams,
    undefined,
    undefined,
    officeIDs,
    true
  );
  return { status, result };
};
